import { Box } from '@mui/material'
import UserChatBubbleFloatingEditMore from './UserChatBubbleFloatingEditMore'
import UserChatBubbleQuickReactions from './UserChatBubbleQuickReactions'
import styles from './index.module.scss'

export default function UserChatBubbleFloatingPopperBody(props) {
  const { floatingToolbarEnter, floatingToolbarLeave } = props
  return (
    <Box
      className={styles.floatingHoverBar}
      component="aside"
      role="toolbar"
      aria-label="Message quick actions"
      onMouseEnter={floatingToolbarEnter}
      onMouseLeave={floatingToolbarLeave}
    >
      <UserChatBubbleQuickReactions {...props} />
      <UserChatBubbleFloatingEditMore {...props} />
    </Box>
  )
}
